import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=1f45e7e8&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45e7e8",
  null
  
)

export default component.exports